import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-down",
  "use": "svg_arrow-down-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 8\" id=\"svg_arrow-down\"><path stroke=\"#000\" stroke-width=\"2\" d=\"m2 1 5 5 5-5\" fill=\"none\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol